import React, { useEffect } from 'react';
import { Grid, Box, Link } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

type DegreesFieldProps = {
  degrees?: {
    degree: string;
  }[];
};
const DegreesField = (props: DegreesFieldProps) => {
  const { degrees } = props;

  const [degreesState, setDegreesState] = React.useState(degrees || []);

  useEffect(() => {
    setDegreesState(degrees || []);
  }, [degrees]);

  return (
    <Grid display={'flex'} gap={5} flexDirection={'column'} p={5}>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='degrees'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          Degrees
        </label>
        {degreesState?.map((degree, index) => {
          return (
            <Grid key={index} display={'flex'} alignItems={'center'} flex={1}>
              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                }}>
                <CustomTextField
                  name='degrees'
                  sx={{ width: '100%', maxWidth: '654px' }}
                  value={degree?.degree || ''}
                  // defaultValue={"firstName" || ""}
                  // onChange={function (
                  //   e: React.ChangeEvent<HTMLInputElement>
                  // ): void {
                  //   setDegreesState((prev) => {
                  //     const newDegrees = [...prev];
                  //     newDegrees[index].degree = e.target.value;
                  //     return newDegrees;
                  //   });

                  //   // throw new Error("Function not implemented.");
                  // }}
                  onChange={() => {}}
                />
                <Link
                  color={'##000000'}
                  sx={{ color: '#000000', fontSize: '17px', fontWeight: 400 }}>
                  Add a Degree
                </Link>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default DegreesField;
